import React from 'react';

const NoMatch = () => {
    return (
        <div className="columns is-vcentered is-flex is-justify-content-center mt-6" style={{ marginTop: '10vh', height: '50vh' }}>
            <div className="column is-half mr-5 mb-5 is-hidden-touch has-text-centered is-unselectable error-img-anim">
                <img src="/images/svg/404.svg" alt="404 svg image" />
            </div>

            <div className="column has-text-centered is-half ml-4 mt-5">
                <h1 className="is-size-1 has-text-weight-bold has-text-primary">Erreur!</h1>
                <p className="is-size-5 has-text-weight-medium"> <span className="has-text-danger">Aie!</span> Page non trouvée...</p>
                <p className="is-size-6 mb-2">La page actuelle n'existe pas ou n'existe plus, si vous pensez que c'est une erreur de notre part n'hésitez pas à nous contacter!</p>
                <div className="buttons is-justify-content-center p-5">
                    <a href="/dashboard/" className="button is-info is-outlined is-invert">Retour au dashboard</a>
                    <a target='_blank' href="/contact" className="button">Nous contacter</a>
                </div>
            </div>
        </div>
    );
};

export default NoMatch;